import type { Brand, Zone } from '@seek/audience-zones';
import type { Country, Language, SiteName } from '@seek/melways-sites';

import type { PageAnalytics } from '.';

export enum PageUpdateActionType {
  SET_CHANGE_EMAIL_SUCCESS = 'SET_CHANGE_EMAIL_SUCCESS',
  SET_DELETE_ACCOUNT_SUCCESS = 'SET_DELETE_ACCOUNT_SUCCESS',
  SET_BRAND_COUNTRY_ZONE = 'SET_BRAND_COUNTRY_ZONE',
}

export interface PageAction {
  type: PageUpdateActionType;
  payload?: PageAnalytics;
}

export const updatePageBrandCountryZone = (
  siteCountry: Country,
  brand: Brand,
  siteLanguage: Language,
  zone: Zone,
  site: SiteName,
) => ({
  type: PageUpdateActionType.SET_BRAND_COUNTRY_ZONE,
  payload: {
    siteCountry,
    siteLanguage,
    brand,
    zone,
    site,
  },
});
